















































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component
export default class MusicSearch extends Vue {
    @Prop()
    songs !: any
    @Prop({default: false})
    more !: boolean

    get audio() {
        return this.$store.getters['getAudio']
    }

    get current() {
        return this.$store.getters['getCurrent']
    }

    convertTime (secs: any) {
        const min = Math.floor(secs / 60);
        const sec = secs % 60;
        const minute = (min < 10) ? "0" + min : min;
        const seconds = (sec < 10) ? "0" + sec : sec;
        return (minute + ':' + seconds);
    }

    playSong (track: any, queue: any) {
        this.audio.src = track.audio
        this.$store.commit('setTracksQueue', queue)
        this.$store.commit('playTrack', track)
        this.audio.play();
    }
}
